module.exports = __webpack_public_path__ + "static/media/payment-done.365689a3.gif";